import CloudDailyBackupSettings from './Daily';

export default CloudDailyBackupSettings;
